import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "angle-down",
  "use": "angle-down-usage",
  "viewBox": "0 0 438 266",
  "content": "<symbol viewBox=\"0 0 438 266\" xmlns=\"http://www.w3.org/2000/svg\" id=\"angle-down\"><path d=\"M202.03 258.477L7.687 64.134c-9.373-9.373-9.373-24.57 0-33.941L30.354 7.526c9.357-9.357 24.522-9.375 33.901-.04l154.746 154.02L373.746 7.485c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.94L235.971 258.477c-9.372 9.373-24.568 9.373-33.941.001z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol